module.exports = __webpack_public_path__ + "static/img/app_icon.de9d4b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/app_icon.png
// module id = fct8
// module chunks = 51